import { render } from "./CreateGroup.vue?vue&type=template&id=2795e6fd&scoped=true&ts=true"
import script from "./CreateGroup.vue?vue&type=script&lang=ts"
export * from "./CreateGroup.vue?vue&type=script&lang=ts"

import "./CreateGroup.vue?vue&type=style&index=0&id=2795e6fd&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2795e6fd"]])

export default __exports__